import { useEffect, useState } from "react";
import instance from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import {getMetaFromTokenURI, getIpfsUrl} from "../utils/meta_in_token"

const NFTManage = ({ setUser }) => {
    const [nfts, setNfts] = useState([]);
    
    const [message, setMessage] = useState("");
    const navigate = useNavigate();


    useEffect(() => {
        const fetchNFTs = async () => {
            try {
                const res = await instance.get("/nftmanage/me");
                const rawNFTs = res.data.nfts;
            
                const processedNFTs = await Promise.all(
                    rawNFTs.map(async (nft) => {
                        const metadata = await getMetaFromTokenURI(nft.tokenURI);
                        return {
                        ...nft,
                        name: metadata?.name || nft.name,
                        description: metadata?.description || nft.description,
                        displayImage: getIpfsUrl(metadata?.image),
                        };
                    })
                );
            
                setNfts(processedNFTs);
            } catch (error) {
                console.error(" [NFT 불러오기 실패]:", error);
            }
        };
        
        const checkuser = async () => {
            try {
                const res = await instance.get("/user/me", { withCredentials: true }) 
                setUser(res.data.user);
            }
            catch (error){
                setUser(null);
                navigate("/login");
            }
        }
        checkuser();
        fetchNFTs();
    }, [setUser]);


    const getIpfsUrl = (url) => {
        if (!url) return "";
        return url.startsWith("ipfs://")
            ? url.replace("ipfs://", "https://ipfs.io/ipfs/")
            : url;
    };



//  NFT 스캔 요청 함수
    const scanNFTs = async () => {
        setMessage("");

        try {
            const res = await instance.post("/nftmanage/nftscanapi", {}, { withCredentials: true });

            if (res.data.success) {
                setMessage("NFT 트랜잭션 조회 완료!");
            } else {
                setMessage(res.data.message || "조회된 트랜잭션이 없습니다.");
            }
        } catch (error) {
            console.error("NFT 스캔 오류:", error);
            setMessage("NFT 트랜잭션 조회 실패");
        }
    }

return (
    <div>
        <h2>NFT 관리</h2>

        <h3>내 NFT 목록</h3>
        <ul>
            {nfts.length > 0 ? (
                nfts.map((nft, index) => (
                    <li key={index}>
                        <img src={nft.displayImage} alt={nft.name} width="100" />
                        <p>{nft.name}</p>
                    </li>
                ))
            ) : (
                <p>NFT가 없습니다.</p>
            )}
        </ul>

        <div>
            <button onClick={scanNFTs}>
                NFT 트랜잭션 조회
            </button>
            <p>{message}</p>
        </div>
    </div>
);
};
    
    

export default NFTManage;
